import * as React from 'react';
import { LicenseInfo } from '@mui/x-license-pro';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { Avatar, Divider, FormControl, InputLabel, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Menu, MenuItem, Select, useMediaQuery } from '@mui/material';
import { CaseCountSetting } from '../components/CaseCountSetting';
import { TimeRangeSetting } from '../components/TimeRangeSetting';
import { AllAreaSetting } from '../components/AllAreaSetting';
import { siteConfig } from "../config/site";
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { SettingContext } from '../App';
import { Alert, Button, Typography } from '@material-tailwind/react';
import { Suspense } from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { UserCircleIcon } from "@heroicons/react/24/solid";
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import {
    CardHeader,
    CardBody,
    CardFooter,
} from "@material-tailwind/react";
import { AreaSetting } from '../components/AreaSetting';
import { Apps } from '@mui/icons-material';
import { DashboardDialog } from '../components/DashboardDialog';


const drawerWidth = 300;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        [theme.breakpoints.only('xs')]: {
            marginLeft: 0,
        },
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        [theme.breakpoints.only('xs')]: {
            width: "100%",
        },
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE);

export default function MainLayout() {
    const theme = useTheme();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { state, dispatch, setting, setSetting } = React.useContext(SettingContext);
    // const [setting, setSetting] = useState(state.setting)
    // console.log(setting)

    const [open, setOpen] = React.useState((window.screen.width < 600)? false : true);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const location = useLocation();
    let navigate = useNavigate()
    // const page404 = siteConfig.pageItems.findIndex(item=>{return item.key === location.pathname.split("/")[1]})
    const [page, setPage] = React.useState(location.pathname === "/" ? "larval" : location.pathname.split("/")[1]);
    const [openAlert, setOpenAlert] = React.useState(false);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [appsAnchorEl, setAppsAnchorEl] = React.useState(null);
    const [dashOpen, setDashOpen] = React.useState(false);


    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleApps = (event) => {
        setAppsAnchorEl(event.currentTarget);
    };

    const handleAppsClose = (event) => {
        setAppsAnchorEl(null);
    };

    const handleDashOpen = () => {
        setDashOpen(true);
    };

    const handleSignoutClick = () => {
        localStorage.removeItem("trb.setting")
        setAnchorEl(null);
        setAppsAnchorEl(null);
        state.iaam.end_session()
        // dispatch({
        //     type: "LOGOUT"
        // })
    }

    function handleReportChange(event) {
        if(isMobileScreen){
            handleDrawerClose()
        }
        setPage(event.target.value)
        navigate("/" + event.target.value)
        dispatch({
            type: "ON_PAGE_CHANGE",
            payload: { page_selected: event.target.value }
        })
        
    }

    const reload = () => {
        setOpenAlert(false)
        window.location.reload(false)
    };

    const isValidAreaSelected = (setting) => {
        let valid = true

        if (setting.display.area.selected === 'AMPHUR') {
            valid = setting.display.area.AMPHUR.startsWith(setting.display.area.PROV) ? true : false
            return valid
        }
        else if (setting.display.area.selected === 'TAMBON') {
            valid = (setting.display.area.TAMBON.startsWith(setting.display.area.AMPHUR) && setting.display.area.AMPHUR.startsWith(setting.display.area.PROV)) ? true : false
        }

        return valid

    }

    const isValidYearComparison = (setting) => {

        if (setting.case_count.comparison.years.length === 0) {
            return false
        }
        else return true

    }

    React.useEffect(() => {
        if (setting) {
            let local_setting = localStorage.getItem('trb.setting')
            // console.log(state)
            // console.log(local_setting)
            if (JSON.stringify(setting) !== local_setting && isValidAreaSelected(setting) && isValidYearComparison(setting)) {
                setOpenAlert(true)
                // localStorage.setItem('trb.setting', JSON.stringify(setting));    
            }
            else {
                setOpenAlert(false)
            }
        }
        else {
            // console.log(state.setting)
            setSetting({ ...state.setting })
        }

    }, [state.setting, setting])

    const onSummitSetting = () => {
        setOpenAlert(false)
        localStorage.setItem('trb.setting', JSON.stringify(setting));
        dispatch({
            type: "SUBMIT_SETTING",
            payload: setting
        })
    }

    const getTimeSetting = (state) => {
        switch (state.page_selected) {
            case "case":
                return <CaseCountSetting />
            default:
                return <TimeRangeSetting />
        }
    }

    const getAreaSetting = (state) => {
        switch (state.page_selected) {
            case "larval":
                return <AllAreaSetting />
            case "container":
                return <AreaSetting />
            case "execution":
                return <AllAreaSetting />
            default:
                return <AreaSetting />
        }
    }

    const drawerItem = (
        <div className='overflow-hidden h-full bg-gradient-to-tr from-red-50 via-gray-100 to-slate-50'>
            <DrawerHeader className='flex items-center justify-between py-4 px-4'>
                <Typography variant="h5" color="blue-gray" className="font-primary">
                    ตั้งค่า
                </Typography>
                <IconButton onClick={handleDrawerClose}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={2}
                        stroke="currentColor"
                        className="h-5 w-5"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>

                </IconButton>
            </DrawerHeader>
            <div className="mb-6 mt-2 px-4">
                <FormControl className="w-full">
                    <InputLabel id="report-select-label" >รายงาน</InputLabel>
                    <Select
                        labelId="report-select-label"
                        id="report-select"
                        value={page}
                        label="รายงาน"
                        size="small"
                        onChange={handleReportChange}
                        MenuProps={{
                            sx: {
                                "&& .Mui-selected": {
                                    backgroundColor: "#b73238",
                                    color: "#fff"
                                },
                                "&& .MuiMenuItem-root:hover": {
                                    backgroundColor: "#ffebee",
                                    color: "#000"
                                }
                            }
                        }}
                    >
                        {siteConfig.pageItems.map(({ title, key }) => (
                            <MenuItem value={key} key={key}>{title}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <section className='w-full h-full overflow-auto px-4 pb-[160px]'>
                {getTimeSetting(state)}
                <Typography className="font-primary my-2 font-bold">การแสดงผล</Typography>
                {getAreaSetting(state)}
            </section>

        </div>
    )

    return (
        <Box sx={{ display: 'flex', overflow: 'hidden' }} >
            <CssBaseline />
            <AppBar position="fixed" open={open}>
                <Toolbar className='bg-white bg-gradient-to-bl from-red-50 via-gray-100 to-slate-50'>
                    <Box display='flex' flexGrow={1}>
                        <IconButton
                            color="blue-gray"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            sx={{ mr: 2, ...(open && { display: 'none' }) }}
                        >
                            <Bars3Icon className="h-6 w-6" />
                        </IconButton>
                        
                        {!isMobileScreen && (
                            <img className="h-6 w-6 my-1.5" alt="candice" src="/img/LogoReport.png" />
                        )}
                        <Typography
                            as="a"
                            href="#"
                            className="mx-2 cursor-pointer py-1.5 text-black font-primary font-bold tracking-wide text-lg"
                        >
                            ทันระบาด<span className="text-red-900">รายงาน</span>
                        </Typography>
                        
                    </Box>
                    <div>
                        <IconButton
                            size="large"
                            aria-label="show 17 new notifications"
                            color="inherit"
                            onClick={handleDashOpen}
                            title='Dashboard'
                            >
                                <InsertChartIcon id="dashboard" className="h-5 w-5 text-lg text-red-900" />
                            
                        </IconButton>
                        <IconButton
                        size="large"
                        aria-label="show 17 new notifications"
                        color="inherit"
                        title='Applications'
                        onClick={handleApps}
                        >
                            <Apps id="apps" className="h-5 w-5 text-lg text-red-900" />
                           
                        </IconButton>
                        <Menu
                            id="apps-appbar"
                            anchorEl={appsAnchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(appsAnchorEl)}
                            onClose={handleAppsClose}
                        >
                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                {state.profile.apps.map((item, idx) => (
                                    <div key={item.client_name}>
                                    <ListItem key={item.client_name} disablePadding alignItems="flex-start">
                                        <ListItemButton component="a" href={item.redirect_urls}>
                                            <ListItemAvatar>
                                                {item.logo_url === "" ? 
                                                (<Avatar className='bg-deep-orange-700 font-primary p-2' src={item.logo_url}>
                                                    {item.client_name[0].toUpperCase()}
                                                </Avatar>)
                                                :(<img className='w-10 h-auto' alt={item.client_name} src={item.logo_url}/>)}
                                                
                                                
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={item.is_default === 0 ? (<span>{item.client_name}<VerifiedUserIcon color="success" fontSize="small" className='pl-1 pb-1'/></span>) : (item.client_name)} 
                                                secondary={item.description} />
                                        </ListItemButton>
                                    </ListItem>
                                    {idx < state.profile.apps.length-1 && <Divider/>}
                                    </div>
                                ))}
                            </List>
                        </Menu>

                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            title='Profile'
                            onClick={handleMenu}
                        >
                            <UserCircleIcon className="h-5 w-5 text-lg text-red-900" />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            {/* <MenuItem className='font-primary' onClick={handleProfileClick}>โพรไฟล์</MenuItem>
                            <MenuItem className='font-primary' onClick={handleSignoutClick}>ออกจากระบบ</MenuItem> */}
                            <div className="w-80">
                                <CardHeader floated={false} className="h-fit">
                                    <img src={"/img/" + state.profile.gender + ".jpg"} alt="profile-picture" />
                                </CardHeader>
                                <CardBody className="text-center">
                                    <Typography variant="h5" className="mb-2 font-primary text-red-900">
                                        {state.profile.displayName}
                                    </Typography>
                                    <Typography color="blue-gray" className="font-medium font-primary" textGradient>
                                        {state.profile.org_name}
                                    </Typography>
                                    <Typography color="blue-gray" className="font-medium font-primary text-sm" textGradient>
                                        {state.profile.mail}
                                    </Typography>
                                    <a href={process.env.REACT_APP_IAAMREG_HOST} className="inline-block mt-2">
                                        <Button size="sm" variant="text" className="w-full flex items-center gap-2 font-primary text-base">
                                            จัดการโพรไฟล์
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth={2}
                                                stroke="currentColor"
                                                className="h-4 w-4"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                                                />
                                            </svg>
                                        </Button>
                                    </a>
                                </CardBody>
                                <CardFooter className="pt-0">
                                    <Button
                                        ripple={false}
                                        fullWidth={true}
                                        onClick={handleSignoutClick}
                                        className="font-primary text-base bg-blue-gray-900/10 text-blue-gray-900 shadow-none hover:scale-105 hover:shadow-none focus:scale-105 focus:shadow-none active:scale-100"
                                    >
                                        ออกจากระบบ
                                    </Button>
                                </CardFooter>
                            </div>
                        </Menu>
                    </div>
                </Toolbar>
            </AppBar>
            <Drawer
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    width: "90%",
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: "90%",
                        boxSizing: 'border-box',
                    },
                }}
                variant="temporary"
                anchor="left"
                open={open}
            >
                {drawerItem}
                <Alert open={openAlert} className="mt-auto mx-4 mb-4 w-auto bg-red-900" onClose={() => reload()}>
                    <Typography variant="h6" className="mb-1 font-primary">
                        อัพเดทการแสดงผล
                    </Typography>
                    <div className="mt-4 flex gap-3">
                        <Typography
                            as="a"
                            href="#"
                            variant="small"
                            className="font-medium opacity-80 font-primary"
                            onClick={() => reload()}
                        >
                            ยกเลิก
                        </Typography>
                        <Typography as="a" href="#" variant="small" className="font-bold font-primary" onClick={() => {handleDrawerClose(); onSummitSetting()}}>
                            อัพเดท
                        </Typography>
                    </div>
                </Alert>
            </Drawer>
            <Drawer
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={open}
            >
                {drawerItem}
                <Alert open={openAlert} className="mt-auto mx-4 mb-4 w-auto bg-red-900" onClose={reload}>
                    <Typography variant="h6" className="mb-1 font-primary">
                        อัพเดทการแสดงผล
                    </Typography>
                    <div className="mt-4 flex gap-3">
                        <Typography
                            as="a"
                            href="#"
                            variant="small"
                            className="font-medium opacity-80 font-primary"
                            onClick={reload}
                        >
                            ยกเลิก
                        </Typography>
                        <Typography as="a" href="#" variant="small" className="font-bold font-primary" onClick={onSummitSetting}>
                            อัพเดท
                        </Typography>
                    </div>
                </Alert>
            </Drawer>
            <Main open={open} className='p-0 mt-[60px] overflow-auto'>
                <Suspense>
                    <Outlet />
                </Suspense>
            </Main>
            <DashboardDialog open={dashOpen} setOpen={setDashOpen} />
        </Box>
    );
}